function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-pascal-case */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { BrowserView, MobileView } from 'react-device-detect';
import Immutable from 'immutable';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { LocalForm } from "../../Forms/Form";
import { MetadataFormFields, validator, prepareMetadataAndFiles } from "../../Metadata";
import { Translate } from "../../I18N";
import { publicSubmit } from "../../Uploads/actions/uploadsActions";
import { FormGroup } from "../../Forms";
import { Icon } from "../../UI";
import { Loader } from "../../components/Elements/Loader";
import "./scss/public-form.scss";
import { generateID } from "../../../shared/IDGenerator";
import { FormCaptcha } from "./FormCaptcha";

class PublicFormComponent extends Component {
  static renderTitle(template) {
    const titleProperty = template.get('commonProperties').find((p) => p.get('name') === 'title');
    const useGeneratedId = Boolean(titleProperty.get('generatedId'));
    let input = /*#__PURE__*/_jsx(Control.text, { id: "title", className: "form-control", model: ".title" });
    if (useGeneratedId) {
      input = /*#__PURE__*/React.cloneElement(input, { defaultValue: generateID(3, 4, 4) });
    }
    return /*#__PURE__*/(
      _jsx(FormGroup, { model: ".title" }, "title", /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "title" }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: template.get('_id') }, void 0, titleProperty.get('label')), /*#__PURE__*/
      _jsx("span", { className: "required" }, void 0, "*")
      )
      ), /*#__PURE__*/
      _jsx("li", { className: "wide" }, void 0, input)
      )
      ));

  }

  static renderSubmitState() {
    return /*#__PURE__*/(
      _jsx("div", { className: "public-form submiting" }, void 0, /*#__PURE__*/
      _jsx("h3", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Submitting")
      ), /*#__PURE__*/
      _jsx(Loader, {})
      ));

  }

  constructor(props) {
    super(props);
    this.removeAttachment = this.removeAttachment.bind(this);
    this.fileDropped = this.fileDropped.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validators = _objectSpread({
      captcha: { required: (val) => val && val.text.length } },
    validator.generate(props.template.toJS()));

    const generatedIdTitle = props.template.
    get('commonProperties').
    find((p) => p.get('name') === 'title' && p.get('generatedId') === true);
    this.state = { submiting: false, files: [], generatedIdTitle };
    this.refreshFn = (refresh) => {
      this.refreshCaptcha = refresh;
    };
  }

  async handleSubmit(_values) {
    const { submit, remote } = this.props;
    const values = await prepareMetadataAndFiles(
      _values,
      this.state.files,
      this.props.template.toJS()
    );
    try {
      this.setState({ submiting: true });
      const submitResult = await submit(values, remote);
      await submitResult.promise;
      this.resetForm();
      this.setState({ submiting: false, files: [] });
    } catch (e) {
      this.setState({ submiting: false });
    }
    this.refreshCaptcha();
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  async removeAttachment(removedFile) {
    await this.setState((prevState) => ({
      files: prevState.files.filter((file) => file !== removedFile)
    }));
    if (!this.state.files.length) {
      const input = document.querySelector('#upload-button');
      input.value = '';
    }
  }

  resetForm() {
    this.formDispatch(actions.reset('publicform'));
    if (this.state.generatedIdTitle) {
      this.formDispatch(actions.load('publicform', { title: generateID(3, 4, 4) }));
    }
  }

  async fileDropped(files) {
    const uploadedFiles = files;
    this.state.files.forEach((file) => uploadedFiles.push(file));
    this.setState((prevState) => _objectSpread(_objectSpread({}, prevState), {}, { files: uploadedFiles }));
  }

  renderFileField(id, options) {
    const defaults = { className: 'form-control on-mobile', model: `.${id}` };
    const props = Object.assign(defaults, options);
    return /*#__PURE__*/(
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("li", { className: "attachments-list" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, id === 'file' ? 'Document' : 'Attachments'), /*#__PURE__*/
      _jsx(BrowserView, {}, void 0, /*#__PURE__*/
      _jsx(Dropzone, {
        onDrop: this.fileDropped,
        className: "dropzone",
        accept: id === 'file' ? { 'application/pdf': ['.pdf'] } : undefined }, void 0,

      ({ getRootProps, getInputProps }) => /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("div", getRootProps(), /*#__PURE__*/
      _jsx("div", { className: "drop-zone" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "text-content" }, void 0, /*#__PURE__*/
      _jsx("div", { id: "icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "cloud-upload-alt" })
      ), /*#__PURE__*/
      _jsx("div", { id: "upload-text" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Drop your files here to upload or")
      )
      )
      ), /*#__PURE__*/

      React.createElement("input", _extends({ id: "upload-button" }, getInputProps())), /*#__PURE__*/
      _jsx("button", { id: "button", type: "button" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Select files on your device")
      )
      )
      )

      )
      ), /*#__PURE__*/
      _jsx(MobileView, {}, void 0, /*#__PURE__*/
      React.createElement(Control.file, _extends({
        id: id },
      props, {
        onChange: (e) => this.fileDropped([...e.target.files]) })
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "preview-list" }, void 0, /*#__PURE__*/
      _jsx("ul", {}, void 0,
      this.state.files.map((file) => /*#__PURE__*/
      _jsx("li", {}, file.preview, /*#__PURE__*/
      _jsx("div", { className: "preview-title" }, void 0, file.name), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("span", { onClick: () => this.removeAttachment(file) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" }), "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Remove")
      )
      )
      )
      )
      )
      )
      )
      )
      ));

  }

  render() {
    const { template, thesauris, file, attachments } = this.props;
    const { submiting } = this.state;
    return /*#__PURE__*/(
      _jsx(LocalForm, {
        validators: this.validators,
        model: "publicform",
        getDispatch: (dispatch) => this.attachDispatch(dispatch),
        onSubmit: this.handleSubmit }, void 0,

      submiting && PublicFormComponent.renderSubmitState(),
      !submiting && /*#__PURE__*/
      _jsx("div", { className: "public-form" }, void 0,
      PublicFormComponent.renderTitle(template), /*#__PURE__*/
      _jsx(MetadataFormFields, {
        thesauris: thesauris,
        model: "publicform",
        template: template,
        boundChange: (formModel, value) =>
        this.formDispatch(actions.change(formModel, value)) }

      ),
      file ? this.renderFileField('file', { accept: '.pdf' }) : false,
      attachments ? this.renderFileField('attachments', { multiple: 'multiple' }) : false, /*#__PURE__*/
      _jsx(FormCaptcha, { remote: this.props.remote, refresh: this.refreshFn }), /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-success" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Submit")
      )
      )

      ));

  }
}








export const mapStateToProps = (state, props) => {
  const template = state.templates.find((tpl) => tpl.get('_id') === props.template);
  if (template === undefined) {
    throw new Error('The template is not valid');
  }
  return {
    template,
    thesauris: state.thesauris,
    file: props.file !== undefined,
    remote: props.remote !== undefined,
    attachments: props.attachments !== undefined
  };
};
export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ submit: publicSubmit }, dispatch);
}
export { PublicFormComponent };
export default connect(mapStateToProps, mapDispatchToProps)(PublicFormComponent);